import React, { useState } from 'react'
import clsx from 'clsx'
import IconChevronRight from 'components/ui/Icon/IconChevronRight'

export interface Props {
  size?: 'sm' | 'md'
  showBorders?: boolean
  isOpenByDefault?: boolean
  headline: string
  children: React.ReactNode
}

const ShortListItem: React.FC<Props> = ({
  size = 'md',
  showBorders = true,
  isOpenByDefault = false,
  headline = undefined,
  children = undefined,
}) => {
  const [isActive, setIsActive] = useState(isOpenByDefault)

  return (
    <div className={`${showBorders ? 'border-t border-gray-200 last:border-b' : ''}`}>
      <button
        className={`flex w-full items-center space-x-4 py-4 ${
          size === 'md' ? 'md:space-x-6' : 'md:space-x-3'
        } md:py-5`}
        type="button"
        onClick={() => setIsActive(!isActive)}
      >
        <span
          className={clsx(
            `flex ${
              size === 'md' ? 'h-8 w-8' : 'h-4 w-4'
            } flex-shrink-0 items-center justify-center rounded-full bg-gray-100`,
            'transition-colors duration-200 ease-in-out',
            `${size === 'md' ? 'md:h-10 md:w-10' : 'md:h-5 md:w-5'}`,
            'hover:bg-gray-200',
            isActive && 'rotate-90'
          )}
        >
          <IconChevronRight size={size === 'md' ? '20' : '8'} />
        </span>

        <span className={`font-semibold ${size === 'md' ? 'text-lg md:text-2xl' : 'text-base'}`}>
          {headline}
        </span>
      </button>

      <div className={clsx(isActive ? 'block' : 'hidden')}>
        <div
          className={
            size === 'md' ? 'pb-8 md:pb-16 md:pl-16 md:pt-4' : 'pb-4 md:pb-8 md:pl-8 md:pt-2'
          }
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default ShortListItem
